import { mode, transparentize } from '@chakra-ui/theme-tools';

/**
 * TODO: dodanie stylowania containera dla stanów checked, focus
 * @see https://github.com/chakra-ui/chakra-ui/issues/4647
 */
export const baseStyle = props => {
  const { colorScheme: c } = props;
  const primaryColor = mode(`${c}.400`, `${c}.600`)(props);
  const secondaryColor = mode(`${c}.200`, `${c}.600`)(props);
  return {
    label: {
      fontWeight: 'medium',
      color: c === 'graphite' ? 'inherit' : primaryColor,
    },
    container: {
      borderColor: secondaryColor,
      cursor: 'pointer',
    },
    control: {
      borderColor: primaryColor,
      borderWidth: '1px',
      padding: '1px', // kompensacja za zmniejszenie borderWidth, inaczej ikony nie będą wyśrodkowane
      backgroundColor: 'transparent',
      _checked: {
        color: 'white',
        borderColor: primaryColor,
        backgroundColor: primaryColor,
        _hover: {
          borderColor: primaryColor,
          backgroundColor: primaryColor,
        },
      },
      _focus: {
        boxShadow: 'none',
      },
    },
  };
};

export const variantGhost = props => {
  const { colorScheme: c, theme } = props;

  return {
    container: {
      borderRadius: 'sm',
      paddingX: '0.5em',
      paddingY: '.25em',
      bg: 'transparent',
      _hover: {
        bg: transparentize(`${c}.500`, 0.12)(theme),
      },
      _active: {
        bg: transparentize(`${c}.500`, 0.24)(theme),
      },
    },
  };
};

export const variantSimpleCheckboxGroup = props => {
  return {
    container: {
      borderRadius: 'sm',
      paddingX: '0.5em',
      paddingY: '.25em',
      bg: 'transparent',
      textTransform: 'none',
      _hover: {
        bg: mode('gray.100', 'WPPgray.100')(props),
      },
      _active: {
        bg: mode('gray.100', 'WPPgray.100')(props),
      },
    },
    label: {
      fontSize: 'xs',
      fontWeight: 'normal',
      py: 1,
    },
    control: {
      border: 'none',
      backgroundColor: 'transparent',
      _checked: {
        border: 'none',
        backgroundColor: 'transparent',
        _hover: {
          border: 'none',
          backgroundColor: 'transparent',
        },
      },
    },
    icon: {
      color: 'black',
    },
  };
};

export const variantOutline = props => {
  const { container: ghostContainer } = variantGhost(props);
  return {
    container: {
      ...ghostContainer,
      borderWidth: '1px',
    },
  };
};

export const variants = {
  ghost: variantGhost,
  outline: variantOutline,
  simpleCheckboxGroup: variantSimpleCheckboxGroup,
  // NOWY WARIANT
  green: {
    control: {
      borderColor: 'gray.200',
      backgroundColor: 'white.100',
      borderRadius: '100%',
      width: '1.5rem',
      height: '1.5rem',
      _checked: {
        backgroundColor: '#B0F467',
        borderColor: 'gray.200',
        color: 'graphite.500',
        _hover: {
          backgroundColor: '#b0f467',
          borderColor: 'gray.200',
        },
      },
      _hover: {
        borderColor: 'gray.200',
        backgroundColor: '#B0F467',
      },
      _disabled: {
        borderColor: 'gray.100',
        backgroundColor: 'gray.50',
        color: 'gray.200',
        _hover: {
          backgroundColor: 'gray.50',
          borderColor: 'gray.100',
        },
      },
    },
    label: {
      // opcjonalnie styl labelki
    },
  },
};

const sizes = {
  sm: {
    control: {
      width: '.8rem',
      height: '.8rem',
    },
    icon: {
      fontSize: '.5rem',
    },
    label: {
      fontSize: 'xs',
    },
  },
  md: {
    label: {
      fontSize: 'sm',
    },
    icon: {
      fontSize: '.5rem',
    },
  },
};

const defaultProps = {
  variant: 'outline',
  colorScheme: 'graphite',
  size: 'md',
};

export default {
  baseStyle,
  variants,
  sizes,
  defaultProps,
};
